<template>
	<div class="mobile-name-header d-flex align-items-center pl-3">
		<img
			@click="$emit('go-back')"
			src="../assets/Images/optionsmodal/backarrow.svg"
			alt=""
		/>
		<h5 class="fs-18 fw-500 font-lato color-white ml-2 my-0">
			{{ labeltext }}
		</h5>
	</div>
</template>

<script>
export default {
	props: {
		labeltext: {
			type: String,
			default: "Label",
		},
	},
};
</script>

<style>
.mobile-name-header {
	height: 48px;
	background: rgba(32, 33, 36, 0.6);
	border: 1px solid rgba(140, 140, 140, 0.33);
	border-radius: 0px;
}
</style>
